const FRAGMENT_KEY = 't';

export function readAndClearLinkToken(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const hash = window.location.hash.slice(0, 600);
  if (!hash.startsWith('#')) {
    return null;
  }
  const params = new URLSearchParams(hash.slice(1));
  const token = params.get(FRAGMENT_KEY)?.trim().slice(0, 512) ?? '';
  if (!token || !token.includes('.')) {
    return null;
  }
  params.delete(FRAGMENT_KEY);
  const remainder = params.toString();
  const nextHash = remainder ? `#${remainder}` : '';
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}${nextHash}`);
  return token;
}
